import ActionTypes from "./types";
import httpClient from "../../lib/HttpClient";

export default () => (dispatch) =>
  new Promise(async (resolve, reject) => {
    try {
      const response = await httpClient.get("/dashboard_data.json");
      dispatch({
        type: ActionTypes.FETCH_DASHBOARD_DATA,
        payload: response.data,
      });
      resolve(response.data);
    } catch (error) {
      reject(error);
    }
  });
